import { TextField, Typography } from "@suraasa/placebo-ui"
import { useEffect } from "react"
import { useFormContext } from "react-hook-form"

import { SIGNATURE_FIELD_NAME } from "../constants"
import { getSignatureError } from "../utils"

const isValidName = (value: unknown) => getSignatureError(value) === null

/**
 * Rendered on every agreement document. All documents share the same form
 * field, so typing the name once pre-fills it everywhere.
 */
const SignatureField = () => {
  const {
    register,
    getValues,
    clearErrors,
    formState: { errors },
  } = useFormContext()

  const error = errors[SIGNATURE_FIELD_NAME]?.message as string | undefined

  const { onChange, ...field } = register(SIGNATURE_FIELD_NAME, {
    validate: value => getSignatureError(value) ?? true,
  })

  /**
   * The field is shared across documents, so a stale error from a previous
   * document must not carry over onto an already valid pre-filled name.
   */
  useEffect(() => {
    if (isValidName(getValues(SIGNATURE_FIELD_NAME))) {
      clearErrors(SIGNATURE_FIELD_NAME)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="rounded border border-surface-200 bg-surface-100 p-1.5">
      <Typography variant="strongSmallBody" className="mb-0.5">
        Type your full name to sign this document
      </Typography>
      <TextField
        placeholder="Enter your full name"
        autoComplete="name"
        errors={error}
        helperText={error}
        onChange={event => {
          onChange(event)
          if (isValidName(event.target.value)) {
            clearErrors(SIGNATURE_FIELD_NAME)
          }
        }}
        {...field}
      />
    </div>
  )
}

export default SignatureField
